import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { motion } from 'framer-motion';

const NotFoundPage = () => {
  const { currentLang } = useLanguage();
  const isAr = currentLang === 'ar';

  useEffect(() => {
    document.title = isAr ? '404 — الصفحة غير موجودة | أرمان كيتشنز' : '404 — Page Not Found | Arman Kitchens';
  }, [isAr]);

  return (
    <main className="min-h-screen flex items-center justify-center bg-brand-dark text-white text-center p-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <p className="text-8xl font-bold text-gold mb-4">404</p>
        <h1 className="text-3xl font-bold mb-4">
          {isAr ? 'الصفحة غير موجودة' : 'Page Not Found'}
        </h1>
        <p className="text-white/60 mb-8 max-w-md mx-auto">
          {isAr
            ? 'عذراً، الصفحة التي تبحث عنها غير موجودة أو ربما تم نقلها.'
            : "Sorry, the page you're looking for doesn't exist or may have been moved."}
        </p>
        <Link
          to="/"
          className="bg-gold text-charcoal px-8 py-3 font-medium inline-block hover:bg-gold/90 transition-colors"
        >
          {isAr ? 'العودة للرئيسية' : 'Back to Home'}
        </Link>
      </motion.div>
    </main>
  );
};

export default NotFoundPage;
